import hexToRgba from 'hex-rgba';
import colors from './colors';
var black = colors.black,
    gray = colors.gray,
    negative = colors.negative,
    accent = colors.accent,
    white = colors.white;
var lightPalette = {
  background: {
    neutral: {
      primary: '#FFFFFF',
      secondary: '#FAF9FC',
      tertiary: '#F1F0F5',
      popover: '#FFFFFF',
      primaryTransparent: 'rgba(255, 255, 255, 0.56)',
      tertiaryTransparent: 'rgba(241, 240, 245, 0.56)',
      dialogOverlay: 'rgba(0, 0, 0, 0.32)'
    },
    semantic: {
      warning: '#FFF2C9',
      accent: '#FFEBE0',
      positive: '#DCF0E8',
      negative: '#FCE3E3',
      positiveGradient: 'linear-gradient(180deg, #171C1B 0%, #142B22 50.47%, #0F402E 100%)',
      negativeGradient: 'linear-gradient(180deg, #29181A 0%, #3B1A1E 50.99%, #63181A 100%)'
    }
  },
  label: {
    accent: '#F06F37',
    accentHigh: '#D9602D',
    accentHighest: '#B74E21',
    primary: '#202023',
    secondary: '#797780',
    secondaryHigh: '#4A494F',
    tertiary: '#95929C',
    tertiaryHigh: '#7C7A82',
    placeholder: '#B1AEB8',
    inactive: 'rgba(122, 120, 130, 0.4)',
    positive: '#1B825E',
    negative: '#E83F41',
    warning: '#D49800',
    inverse: '#FFFFFF',
    primaryActive: '#F06F37',
    secondaryActive: '#4A494F',
    tertiaryActive: '#7C7A82',
    plaseholder: '#B1AEB8'
  },
  fill: {
    primary: {
      highest: '#DA622F',
      high: '#ED6D37',
      mid: '#FF7940',
      low: '#FF976B',
      muted: '#FFBA99',
      overlay32: 'rgba(255, 148, 102, 0.32)',
      overlay24: 'rgba(255, 148, 102, 0.24)',
      overlay16: 'rgba(255, 148, 102, 0.16)',
      overlay8: 'rgba(255, 148, 102, 0.08)'
    },
    secondary: {
      highest: '#28272B',
      high: '#65626B',
      mid: '#95929C',
      low: '#C9C7D1',
      muted: '#E0DFE5',
      overlay32: 'rgba(192, 189, 201, 0.32)',
      overlay24: 'rgba(192, 189, 201, 0.24)',
      overlay16: 'rgba(192, 189, 201, 0.16)',
      overlay8: 'rgba(192, 189, 201, 0.08)'
    },
    positive: {
      highest: '#2B6E5A',
      high: '#1B825E',
      mid: '#1C996D',
      low: '#44BD90',
      muted: '#82D9B5',
      overlay32: 'rgba(68, 189, 144, 0.32)',
      overlay24: 'rgba(68, 189, 144, 0.24)',
      overlay16: 'rgba(68, 189, 144, 0.16)',
      overlay8: 'rgba(68, 189, 144, 0.08)'
    },
    negative: {
      highest: '#D63639',
      high: '#E83F41',
      mid: '#FA4D50',
      low: '#FF7A7F',
      muted: '#FFB0B1',
      overlay32: 'rgba(255, 122, 127, 0.32)',
      overlay24: 'rgba(255, 122, 127, 0.24)',
      overlay16: 'rgba(255, 122, 127, 0.16)',
      overlay8: 'rgba(255, 122, 127, 0.08)'
    },
    note: {
      highest: '#E5A605',
      high: '#F2B818',
      mid: '#FFCB30',
      low: '#FFD549',
      muted: '#FFE591',
      overlay32: 'rgba(255, 198, 28, 0.32)',
      overlay24: 'rgba(255, 198, 28, 0.24)',
      overlay16: 'rgba(255, 198, 28, 0.16)',
      overlay8: 'rgba(255, 198, 28, 0.08)'
    }
  },
  divider: {
    primary: '#E7E6EB',
    secondary: '#DBDADE',
    tertiary: '#D3D2D6',
    altPrimary: '#DDDCE0',
    altSecondary: '#F1F0F5'
  },
  static: {
    backgroundPrimary: '#27272B',
    black: '#0A0A0A',
    blackAlfa72: 'rgba(10, 10, 10, 0.72)',
    blackAlfa56: 'rgba(10, 10, 10, 0.56)',
    blackAlfa24: 'rgba(10, 10, 10, 0.24)',
    blackAlfa16: 'rgba(10, 10, 10, 0.16)',
    blackAlfa8: 'rgba(10, 10, 10, 0.08)',
    blackAlfa4: 'rgba(10, 10, 10, 0.04)',
    white: '#FFFFFF',
    whiteAlfa72: 'rgba(255, 255, 255, 0.72)',
    whiteAlfa56: 'rgba(255, 255, 255, 0.56)',
    whiteAlfa24: 'rgba(255, 255, 255, 0.24)',
    whiteAlfa16: 'rgba(255, 255, 255, 0.16)',
    whiteAlfa8: 'rgba(255, 255, 255, 0.08)',
    whiteAlfa4: 'rgba(255, 255, 255, 0.04)',
    primary: '#FF7C47',
    primaryAlfa32: 'rgba(224, 109, 63, 0.32)',
    secondary: '#A6A3AD',
    secondaryAlfa32: 'rgba(166, 163, 173, 0.32)',
    positive: '#4BBF93',
    negative: '#FF6B6E',
    note: '#FFCB30'
  },
  shadow: {
    button: '0px 1px 3px rgba(0, 0, 0, 0.15)',
    accent: '0px 3px 6px -2px rgba(226, 79, 20, 0.3), 0px 8px 12px rgba(139, 61, 44, 0.1), 0px 9px 16px rgba(56, 56, 67, 0.11)',
    popover: '0px 4px 16px rgba(72, 74, 100, 0.24), 0px 16px 40px rgba(72, 74, 100, 0.16)',
    dialog: '0px 12px 16px rgba(61, 61, 72, 0.1), 0px 24px 56px rgba(61, 61, 72, 0.38)',
    cardEasy: '0px 6px 16px rgba(120, 123, 156, 0.08)',
    cardHeavy: '0px 1px 4px rgba(126, 128, 150, 0.12), 0px 6px 16px rgba(126, 128, 150, 0.2)',
    headerWeb: '0px 1px 4px rgba(126, 128, 150, 0.4), 0px 6px 16px rgba(126, 128, 150, 0.32)'
  },
  base: {
    accent: accent['1'],
    error: negative['1'],
    disabled: gray['3']
  },
  input: {
    main: {
      text: black['1'],
      background: hexToRgba(gray['1'], 8),
      backgroundDisabled: hexToRgba(gray['1'], 4),
      backgroundHover: hexToRgba(gray['1'], 16),
      backgroundError: hexToRgba(negative['1'], 8),
      border: gray['3'],
      borderDisabled: hexToRgba(gray['3'], 56),
      borderHover: gray['1'],
      borderError: negative['1']
    },
    label: gray['1'],
    message: gray['1']
  },
  menuItem: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundSelected: hexToRgba(accent['1'], 16)
  },
  button: {
    backgroundDisabled: hexToRgba(gray['1'], 6),
    border: hexToRgba(accent['1'], 32),
    borderDisabled: hexToRgba(black['1'], 8)
  },
  iconButton: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundFocused: hexToRgba(accent['1'], 16)
  },
  toggle: {
    background: white['1'],
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundActivated: hexToRgba(accent['1'], 16)
  },
  text: {
    primary: black['1'],
    secondary: gray['1']
  },
  paper: {
    background: white['1'],
    shadow: {
      elevation1: '0px 1px 6px rgba(0, 0, 0, 0.12), 0px 1px 4px rgba(0, 0, 0, 0.12)',
      elevation2: '0px 3px 10px rgba(0, 0, 0, 0.23), 0px 3px 10px rgba(0, 0, 0, 0.16)',
      elevation3: '0px 10px 18px rgba(0, 0, 0, 0.22), 0px 14px 45px rgba(0, 0, 0, 0.25)'
    }
  },
  modal: {
    backdrop: hexToRgba(black['0'], 32)
  },
  dialog: {
    background: white['1']
  },
  dropDown: {
    background: white['1']
  },
  dividerLegacy: {
    primary: gray['4'],
    secondary: gray['4']
  },
  switch: {
    icon: white['1'],
    shadow: '0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
    track: gray['2']
  },
  calendar: {
    day: {
      backgroundHover: hexToRgba(gray['1'], 8),
      backgroundCurrent: hexToRgba(accent['1'], 16)
    }
  },
  avatar: {
    backgroundPrimary: gray['5'],
    backgroundSecondary: white['2']
  },
  snackbar: {
    text: white['2'],
    background: black['2']
  },
  tooltip: {
    background: hexToRgba(black['0'], 90),
    color: white['1']
  }
};
export default lightPalette;